import { useCallback } from "react";

const useEscape = (action) => {

    const onKeyDown = useCallback((e) => {
        if (e.keyCode === 27 && action) {
            action();
        }
    }, [action])

    const addListener = () => {
        window.addEventListener("keydown", onKeyDown);
    }

    const removeListerner = () => {
        window.removeEventListener("keydown", onKeyDown);
    }

    return {
        addListener,
        removeListerner
    };
};

export default useEscape;
